module.exports = __webpack_public_path__ + "img/1alB-nh-bzi'inh.a5577252.jpg";